import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Array Map Polyfill",
  url: "array-map-polyfill",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[]} arr
* @param {function()} cb
* @return {number[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function map(arr, cb) {
  // your code goes here        
};
`,
};

export default info;
